export { default } from "./shop.api"
